import Logo from './../../resources/images/logo.svg';
import './index.scss';

function Header() {
    return (
      <header className="header">
          <div className="container">
              <img src={Logo} className="logo" alt="" />
              <ul className="header-social-links">
                  <li className="header-social-link">
                      <a href="https://www.facebook.com/TheSpringNews-100126145945813/" target="_blank" className="bme-icon-facebook">facebook</a>
                  </li>
                  <li className="header-social-link">
                      <a href="https://www.instagram.com/thespringnews/" target="_blank" className="bme-icon-instagram">instagram</a>
                  </li>
                  <li className="header-social-link">
                      <a href="https://twitter.com/TheSpringNews" target="_blank" className="bme-icon-twitter">twitter</a>
                  </li>
                  <li className="header-social-link">
                      <a href="https://www.linkedin.com/company/springnews/" target="_blank" className="bme-icon-linkedin">linkedin</a>
                  </li>
              </ul>
          </div>
      </header>
    )
}

export default Header;
